import ClientDetailsList from './ClientDetailsList';

export default ClientDetailsList;
